module.exports = __webpack_public_path__ + "static/media/proposal_dropoff_pin.f6af2349.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/bubble/images/proposal_dropoff_pin.svg
// module id = 638
// module chunks = 0